import { ApiResponse, getRequest, postRequest } from "@/data/apiClient";
import { UserProfile } from "@/data/repos/commonModels";

export const userProfile = async (
  userProfile: UserProfile
): Promise<ApiResponse<UserProfile>> => getRequest("userProfile", userProfile);

export const userProfiles = async (
  includeParents: boolean
): Promise<ApiResponse<UserProfile[]>> =>
  getRequest("userProfiles", includeParents);

export const userProfileCreate = async (
  userProfile: UserProfile
): Promise<ApiResponse<UserProfile>> =>
  postRequest("userProfileCreate", userProfile);

export const userProfileUpdate = async (
  userProfile: UserProfile
): Promise<ApiResponse<UserProfile>> =>
  postRequest("userProfileUpdate", userProfile);

export const userProfileDelete = async (
  userProfile: UserProfile
): Promise<ApiResponse<UserProfile>> =>
  postRequest("userProfileDelete", userProfile);
